import { parseHtml, toWebp } from "@/utils/common";
import Image from "next/image";
import React, { useState } from "react";

export interface CustomAccordionProps {
  data?: any;
}

const CustomAccordion: React.FC<CustomAccordionProps> = ({ data }) => {
  const items = data?.Techstack;

  const [openId, setOpenId] = useState<number | null>(1);

  const toggleAccordion = (id: number) => {
    setOpenId(openId === id ? null : id);
  };

  const baseUrl = process.env.NEXT_PUBLIC_REACT_APP_RESOURCE_BASE_URL ?? "";

  return (
    <div className="w-full">
      {items?.map((item: any, index: number) => (
        <div
          key={index}
          className="mb-8 last:mb-0 border border-border  bg-white"
        >
          <button
            onClick={() => toggleAccordion(index)}
            className="relative min-h-[48px] border-border  flex w-full items-center text-subtitle-1 font-bold border-1 px-[12px] py-[16px] border-l-10"
          >
            <span className="font-semibold mr-2">{index + 1}.</span>
            <span className="text-subtitle-1 text-start">{item?.title}</span>
          </button>

          {openId === index && item.title && (
            <div className="p-[12px] pt-[24px] ">
              <p className="text-[#000] text-heading-6 font-regular h-auto xl:max-w-[776px] max-w-[776px] mt-[10px] line-clamp-4">
                {parseHtml(item?.description)}
              </p>
              {item?.image?.data?.attributes?.url && (
                <Image
                  src={toWebp(
                    `${baseUrl}${item?.image?.data?.attributes?.url}`
                  )}
                  alt={item.title}
                  height={287}
                  width={358}
                  quality={100}
                  className="mt-12 min-h-[287px] w-full object-cover max-h-[287px]"
                />
              )}
            </div>
          )}
        </div>
      ))}
    </div>
  );
};
export default CustomAccordion;
